import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GeneralV3Response, LoadingType } from "../../../types/CommonTypes";
import { useAppSelector } from "./../redux-hooks";
import { ackAllNotifications, ackNotification, assignNotificationToAnother, deleteAllNotificationsByUser, deleteNotificationById, deleteNotificationDocuments, getAlertedRecordNumbersSkipLoading, getAllSentMessageList, getImportantNotifications, getNotificationList, getNotificationsByRefEntitiesSkipLoading, saveNotificationDocument, sendUserNotification } from "../../../service/NotificationService";
import { Attachment } from "../../../components/operation/inbox/InboxList";

export interface NotificationListDTO {
    notificationId: number,
    notificationType: string | null,
    entity: string | null,
    entityId: number,
    notificationSub?: string | null,
    notificationMsg: string | null,
    targetEntity: string | null,
    targetEntityId: number | null,
    targetName?: string | null,
    senderId: number | null,
    senderName?: string | null,
    senderEmail?: string | null,
    senderProfileDocument?: ProfileDocument | null;
    targetProfileDocument?: ProfileDocument | null;
    important: number,
    auditUserId: number | null,
    auditTimeStamp: string | null,
    attachmentIds: number[] | [],
    notificationAttachment?: notificationAttachmentDTO[] | [],
    notificationAck?: 
    {
        notificationAckId: number,
        notificationId: number,
        ackUsrId: number,
        comment: string | null,
        ackAuditUserId: number,
        ackAuditTimeStamp: string
    }[],
    notificationAsgnTo?:
    {
        notificationAsgnToId: number,
        notificationId: number,
        assignedToUserId: number,
        assignedToAuditUserId: number,
        assignedToAuditTimeStamp: string
    }[]
            
}

export interface NotificationWsUpdate {

    notificationId: number,
    notificationType: string | null,
    entity: string | null,
    entityId: number,
    notificationSub?: string | null,
    notificationMsg: string | null,
    targetEntity: string | null,
    targetEntityId: number | null,
    senderId: number | null,
    senderProfileDocument?: ProfileDocument | null;
    targetProfileDocument?: ProfileDocument | null;
    important: number,
    auditUserId: number | null,
    auditTimeStamp: string | null,
    attachmentIds: number[] | [],
    parentNotification?: NotificationWsUpdate,
    childNotifications?: NotificationWsUpdate[],
    notificationAttachment?: notificationAttachmentDTO[],
    notificationAck?: 
    {
        notificationAckId: number,
        notificationId: number,
        ackUsrId: number,
        comment: string | null,
        ackAuditUserId: number,
        ackAuditTimeStamp: string
    }[],
    notificationAsgnTo?:
    {
        notificationAsgnToId: number,
        notificationId: number,
        assignedToUserId: number,
        assignedToAuditUserId: number,
        assignedToAuditTimeStamp: string
    }[],
    
  pfpMap?: Record<string, string>;

  notificationAttmtId: number,
  documentId: number,
  attmtAuditUserId: number,
  attmtAuditTimeStamp: string,

  notificationAckId: number,
  ackUsrId: number,
  comment: string | null,
  ackAuditUserId: number,
  ackAuditTimeStamp: string,
  ackType: string,

  notificationAsgnToId: number,
  assignedToUserId: number,
  assignedToAuditUserId: number,
  assignedToAuditTimeStamp: string,

  ackedAll: boolean,
  deleteAll: boolean,
  deletedUserId: number,
}

export interface notificationAttachmentDTO{
  notificationAttmtId: number,
  notificationId: number,
  documentId: number,
  documentName: string,
  attmtAuditUserId: number,
  attmtAuditTimeStamp: string
}


export interface PaginationNotificationList {
  content: NotificationListDTO[];
  totalElements: number;
  totalPages: number;
  size: number;
}

export type SearchNotificationListRequest = {
    notificationTypes: string[];
    unread: boolean | true; 
    notificationCategory?: string;
    currentPage?: number;
    itemsPerPage?:number;
}

export type composeNotificationRequest = {
	targetEntity?: string | null
	targetEntityId: number[]
	subject: string
  notificationMsg: string
	important: boolean | false
	attachmentIds?: number[]
}

export type ackNotificationRequest = {
  notificationId: number;
	comment: string;
}

export type assignNotificationRequest = {
  notificationId: number;
	assignedUserId: number;
}

export type getNotificationsByRefEntsRequest = {
  refEntity: string;
  refEntityIds: number[];
}

export type getAlertRecordNumbers = {
  entity: string;
}

export type deleteNotificationRequest = {
  notificationId: number;
  notificationCategory?: string;
}

export type SentboxRequest = {
    notificationTypes: string[];
    currentPage?: number;
}

export interface ProfileDocument {
  fileType: string;
  fileName: string;
  content: string;
}

  const initialState: NotificationListState = {
    notifications: undefined,
    NotificationListInfo: undefined,
    InboxListInfo: undefined,
    NotificationListFetchStatus: "idle",
    InboxListFetchStatus: "idle",
    ImportantListFetchStatus: "idle",
    NotificationInfoByRefEntity: undefined,
    ImportantNotificationInfo: undefined,
    NotificationInfoByRefEntityStatus: "idle"
  };

  type NotificationListState = {
    notifications: NotificationWsUpdate[] | undefined;
    NotificationListInfo?: PaginationNotificationList | null;
    dashboardNotificationListInfo?: PaginationNotificationList | null;
    InboxListInfo?: PaginationNotificationList | null;
    dashboardInboxListInfo?: PaginationNotificationList | null;
    NotificationListFetchStatus?: LoadingType;
    InboxListFetchStatus?: LoadingType;
    ImportantListFetchStatus?: LoadingType;
    NotificationInfoByRefEntity: NotificationListDTO[] | undefined,
    ImportantNotificationInfo: NotificationListDTO[] | undefined,
    NotificationInfoByRefEntityStatus: "idle"
  };

export const fetchNotificationList = createAsyncThunk("fetchNotificationList", async (data: SearchNotificationListRequest) => {
  const response = await getNotificationList(data);
  const v3Response = response.data;
  return v3Response;
});

export const fetchDashboardNotificationList = createAsyncThunk("fetchDashboardNotificationList", async (data: SearchNotificationListRequest) => {
  const response = await getNotificationList(data);
  const v3Response = response.data;
  return v3Response;
});

export const fetchInboxMessageList = createAsyncThunk("fetchInboxMessageList", async (data: SearchNotificationListRequest) => {
    const response = await getNotificationList(data);
    const v3Response = response.data;
    return v3Response;
});

export const fetchDashboardInboxMessageList = createAsyncThunk("fetchDashboardInboxMessageList", async (data: SearchNotificationListRequest) => {
    const response = await getNotificationList(data);
    const v3Response = response.data;
    return v3Response;
});

export const composeNotification = createAsyncThunk("composeNotification", async (data: composeNotificationRequest) => {
  const response = await sendUserNotification(data);
  const v3Response = response.data;
  return v3Response;
});

export const uploadNotificationDocument = createAsyncThunk("uploadNotificationDocument", async (data: Attachment) => {
  const response = await saveNotificationDocument(data);
  const v3Response = response.data;
  return v3Response;
});

export const removeNotificationDocuments = createAsyncThunk("removeNotificationDocuments", async (data: number[]) => {
  const response = await deleteNotificationDocuments(data);
  const v3Response = response.data;
  return v3Response;
});

export const acknowledgeNotification = createAsyncThunk("acknowledgeNotification", async (data: ackNotificationRequest) => {
  const response = await ackNotification(data);
  const v3Response = response.data;
  return v3Response;
});

export const acknowledgeAllNotifications = createAsyncThunk("acknowledgeAllNotifications", async (data: SearchNotificationListRequest) => {
  const response = await ackAllNotifications(data);
  const v3Response = response.data;
  return v3Response;
});

export const fetchNotificationsByRefEntities = createAsyncThunk<any, { data: getNotificationsByRefEntsRequest, skipLoader?: boolean }>("fetchNotificationsByRefEntities", async ({ data, skipLoader = false }) => {
  const response = await getNotificationsByRefEntitiesSkipLoading(data, { 'x-skip-loader': skipLoader.toString() });
  const v3Response = response.data;
  return v3Response;
});

export const fetchAlertEntityNumbers = createAsyncThunk<any, {data: getAlertRecordNumbers, skipLoader?: boolean}>("fetchAlertEntityNumbers", async ({data, skipLoader = false}) => {
  const response = await getAlertedRecordNumbersSkipLoading(data, { 'x-skip-loader': skipLoader.toString() });
  const v3Response = response.data;
  return v3Response;
});

export const assignNotification = createAsyncThunk("assignNotification", async (data: assignNotificationRequest) => {
  const response = await assignNotificationToAnother(data);
  const v3Response = response.data;
  return v3Response;
});

export const fetchImportantNotifications = createAsyncThunk("fetchImportantNotifications", async () => {
  const response = await getImportantNotifications();
  const v3Response = response.data;
  return v3Response;
});

export const deleteNotification = createAsyncThunk("deleteNotification", async (data: deleteNotificationRequest) => {
  const response = await deleteNotificationById(data);
  const v3Response = response.data;
  return v3Response;
});

export const deleteAllNotifications = createAsyncThunk("deleteAllNotifications", async () => {
  const response = await deleteAllNotificationsByUser();
  const v3Response = response.data;
  return v3Response;
});

export const fetchSentboxMessageList = createAsyncThunk("fetchSentboxMessageList", async (data: SentboxRequest) => {
  const response = await getAllSentMessageList(data);
  const v3Response = response.data;
  return v3Response;
});

export const fetchDahboardSentboxMessageList = createAsyncThunk("fetchDahboardSentboxMessageList", async (data: SentboxRequest) => {
  const response = await getAllSentMessageList(data);
  const v3Response = response.data;
  return v3Response;
});

  const NotificationListSlice = createSlice({ 
    name: "NotificationList",
    initialState,
    reducers: {
      clearAllNotifications: () => initialState,
      resetNotificationData: () => {
        return {
          ...initialState,
        };
      },
      resetNotificationList: (state: NotificationListState) => {
        state.NotificationListInfo = undefined;
        state.InboxListInfo = undefined;
        state.NotificationListFetchStatus = "idle";
        state.notifications = undefined;
        state.dashboardInboxListInfo = undefined;
        state.dashboardNotificationListInfo = undefined;
      },
      addNewNotification: (state, action: PayloadAction<any>) => {
        if (state.NotificationListInfo) {
          state.NotificationListInfo.content.unshift(action.payload);

          if (state.NotificationListInfo.content.length > 10) {
            state.NotificationListInfo.content.pop();
            
          }
          if (state.NotificationListInfo.totalElements <10) {
            state.NotificationListInfo.totalElements += 1;
          }

        } else {
          state.NotificationListInfo = {
            content: [action.payload],
            totalElements: 1,
            totalPages: 1,
            size: 10,
          };
        }
      },
      addNewMessage: (state, action: PayloadAction<any>) => {
        if (state.InboxListInfo) {
          state.InboxListInfo.content.unshift(action.payload);

          if (state.InboxListInfo.content.length > 10) {
            state.InboxListInfo.content.pop();
            
          }
          if (state.InboxListInfo.totalElements <10) {
            state.InboxListInfo.totalElements += 1;
          }

        } else {
          state.InboxListInfo = {
            content: [action.payload],
            totalElements: 1,
            totalPages: 1,
            size: 10,
          };
        }
      },
      addWsNotification: (state, action: PayloadAction<NotificationWsUpdate>) => {
        if (!state.notifications) {
          state.notifications = [action.payload];
        } else {
          state.notifications.unshift(action.payload);
        }
    },

    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchNotificationList.pending, (state) => {
          state.NotificationListFetchStatus = "loading";
        })
        .addCase(fetchNotificationList.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
          state.NotificationListFetchStatus = "success";
          // state.NotificationListInfo = action.payload.data;
          state.NotificationListInfo = action.payload?.data; // CS-1984
        })
        .addCase(fetchNotificationList.rejected, (state, action) => {
          state.NotificationListFetchStatus = 'error';
        })
        .addCase(fetchDashboardNotificationList.pending, (state) => {
          state.NotificationListFetchStatus = "loading";
        })
        .addCase(fetchDashboardNotificationList.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
          state.NotificationListFetchStatus = "success";
          // state.dashboardNotificationListInfo = action.payload.data;
          state.dashboardNotificationListInfo = action.payload?.data; // CS-1984
        })
        .addCase(fetchDashboardNotificationList.rejected, (state, action) => {
          state.NotificationListFetchStatus = 'error';
        })
        .addCase(fetchInboxMessageList.pending, (state) => {
          state.InboxListFetchStatus = "loading";
        })
        .addCase(fetchInboxMessageList.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
          state.InboxListFetchStatus = "success";
          // state.InboxListInfo = action.payload.data;
          state.InboxListInfo = action.payload?.data; // CS-1984
        })
        .addCase(fetchInboxMessageList.rejected, (state, action) => {
          state.InboxListFetchStatus = 'error';
        })
        .addCase(fetchDashboardInboxMessageList.pending, (state) => {
          state.InboxListFetchStatus = "loading";
        })
        .addCase(fetchDashboardInboxMessageList.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
          state.InboxListFetchStatus = "success";
          // state.dashboardInboxListInfo = action.payload.data;
          state.dashboardInboxListInfo = action.payload?.data; // CS-1984
        })
        .addCase(fetchDashboardInboxMessageList.rejected, (state, action) => {
          state.InboxListFetchStatus = 'error';
        })
        .addCase(fetchNotificationsByRefEntities.pending, (state) => {
          state.NotificationListFetchStatus = "loading";
        })
        .addCase(fetchNotificationsByRefEntities.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
          state.NotificationListFetchStatus = "success";
          console.log("success")
          // state.NotificationInfoByRefEntity = action.payload.data;
          state.NotificationInfoByRefEntity = action.payload?.data; // CS-1984
        })
        .addCase(fetchNotificationsByRefEntities.rejected, (state, action) => {
          state.NotificationListFetchStatus = 'error';
        })
        .addCase(fetchImportantNotifications.pending, (state) => {
          state.ImportantListFetchStatus = "loading";
        })
        .addCase(fetchImportantNotifications.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
          state.ImportantListFetchStatus = "success";
          console.log("success")
          // state.ImportantNotificationInfo = action.payload.data;
          state.ImportantNotificationInfo = action.payload?.data; // CS-1984
        })
        .addCase(fetchImportantNotifications.rejected, (state, action) => {
          state.ImportantListFetchStatus = 'error';
        })
        .addCase(fetchSentboxMessageList.pending, (state) => {
          state.NotificationListFetchStatus = "loading";
        })
        .addCase(fetchSentboxMessageList.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
          state.NotificationListFetchStatus = "success";
          // state.InboxListInfo = action.payload.data;
          state.InboxListInfo = action.payload?.data; // CS-1984
        })
        .addCase(fetchSentboxMessageList.rejected, (state, action) => {
          state.NotificationListFetchStatus = 'error';
        })
        .addCase(fetchDahboardSentboxMessageList.pending, (state) => {
          state.NotificationListFetchStatus = "loading";
        })
        .addCase(fetchDahboardSentboxMessageList.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
          state.NotificationListFetchStatus = "success";
          // state.dashboardInboxListInfo = action.payload.data;
          state.dashboardInboxListInfo = action.payload?.data; // CS-1984
        })
        .addCase(fetchDahboardSentboxMessageList.rejected, (state, action) => {
          state.NotificationListFetchStatus = 'error';
        })
    },
  });

export const { resetNotificationData, resetNotificationList, addNewMessage, addNewNotification, addWsNotification, clearAllNotifications } = NotificationListSlice.actions;
export const useCreateNotificationSlice = () => useAppSelector((state) => state.createNotificationSlice);
export default NotificationListSlice.reducer;